/**
 * NOTA: la llave de abajo ya está regionalizada.
 *
 * El default aquí abajo no indica región porque
 * ya debería venir filtrada por región desde
 * el middleware de video.
 *
 * key es: third_party_epg_apps
 *
 * Ver documentación en: https://dlatvarg.atlassian.net/browse/STV-13546
 */

export const TPA_APA_DEFAULT_KEY = `{
    "urn://com.netflix.ninja": {
        "epg": {
            "uri": "http://www.netflix.com/browse?iid=9f1e83e6",
            "package": "com.netflix.ninja",
            "action": "ACTION_VIEW",
            "category": null,
            "flags": [
                "FLAG_INCLUDE_STOPPED_PACKAGES"
            ]
        },
        "home": {
            "uri": "http://www.netflix.com/browse?iid=YYYYY",
            "package": "com.netflix.ninja",
            "action": "ACTION_VIEW",
            "category": null,
            "flags": [
                "FLAG_INCLUDE_STOPPED_PACKAGES"
            ]
        },
        "mosaic": {
            "uri": "http://www.netflix.com/browse?iid=XXXX",
            "package": "com.netflix.ninja",
            "action": "ACTION_VIEW",
            "category": null,
            "flags": [
                "FLAG_INCLUDE_STOPPED_PACKAGES"
            ]
        }
    },

    "urn://com.amazon.prime": {
        "epg": {
            "uri": "https://app.primevideo.com/",
            "package": "com.amazon.amazonvideo.livingroom",
            "action": "ACTION_VIEW",
            "category": [],
            "flags": []
        },
        "home": {
            "uri": "https://app.primevideo.com/",
            "package": "com.amazon.amazonvideo.livingroom",
            "action": "ACTION_VIEW",
            "category": [],
            "flags": []
        },
        "mosaic": {
            "uri": "https://app.primevideo.com/",
            "package": "com.amazon.amazonvideo.livingroom",
            "action": "ACTION_VIEW",
            "category": [],
            "flags": []
        }
    }

}`;



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/ThirdPartyAppsDefaultApaKey.js